import React from 'react'
import SidePanelFramework from '@bt-react/components/SidePanelFramework'
import Icon, { IconType } from '@bt-react/components/Icon'
import styles from './detailsSidePanel.module.scss'
import genericStyles from '@bt-react/styles'
import Truncate from 'react-truncate'
import { Tooltip } from 'reactstrap'
import cookie from '@bt-react/libs/cookie'
import utcToZonedTime from 'date-fns-tz/utcToZonedTime'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'
import { DetailsSidePanelProps, DetailsSidePanelState } from './types'

class DetailsSidePanel extends React.PureComponent<DetailsSidePanelProps, DetailsSidePanelState> {

  constructor (props) {

    super(props)
    this.state = {
      descriptionOpen: false,
      truncatedDescription: false,
      timezoneRef: React.createRef<HTMLDivElement>(),
      timezoneTooltipOpen: false
    }

  }

  toggleDescription = () => {

    this.setState({
      descriptionOpen: !this.state.descriptionOpen
    })

  }

  handleTruncateDescription = (truncated) => {

    if (this.state.truncatedDescription !== truncated) {

      this.setState({
        truncatedDescription: truncated
      })

    }

  }

  ToggleDescriptionButton = () => (
    <b data-bdd='toggle-description' className={styles['details-panel-toggle-description-button']} onClick={this.toggleDescription}>{` ...${this.state.descriptionOpen ? 'less' : 'more'}`}</b>
  )

  MetricsBlock = (props) => (
    <div data-bdd={`details-panel-metrics-block${props.dataBdd ? `-${props.dataBdd}` : ''}`} className={`${styles['details-panel-metrics-block']} ${props.className}`} >
      <div data-bdd='details-panel-metrics-block-title' className={styles['details-panel-metrics-block-title']}><b>{props.title}</b></div>
      <div data-bdd='details-panel-metrics-block-content' className={styles['details-panel-metrics-block-content']}>{props.content}</div>
    </div>
  )

  toggleTimezoneTooltip = () => {

    this.setState({
      timezoneTooltipOpen: !this.state.timezoneTooltipOpen
    })

  }

  render () {
    const startTime = this.props.webcast?.start
      ? utcToZonedTime(parseISO(this.props.webcast.start), this.props.user.timeZone)
      : ''

    return <SidePanelFramework
      icon={IconType.iconName.info}
      title="Talk details"
      content={
        this.props.webcast &&
        <div data-bdd='details-panel' className={styles['details-panel-container']}>
          <div data-bdd='details-panel-metrics' className={styles['details-panel-metrics']}>
            {
              startTime &&
              <this.MetricsBlock
                dataBdd='start-date'
                title='Scheduled for'
                className={styles['details-panel-metrics-block-start-date']}
                content={
                  <React.Fragment>
                    <div>{format(startTime, 'MMMM dd yyyy')}</div>
                    <div ref={this.state.timezoneRef}>
                      {format(startTime, 'h:mm a').toLowerCase()}
                      <span className={styles['clock-icon']}>
                        <Icon
                          name={IconType.iconName.clock}/>
                      </span>
                    </div>
                    {
                      this.state.timezoneRef &&
                      <Tooltip
                        data-bdd='tooltip-timezone'
                        placement='bottom'
                        delay={0}
                        container={document.getElementsByClassName(genericStyles['bootstrap-container'])[0] as HTMLElement}
                        cssModule={genericStyles}
                        toggle={this.toggleTimezoneTooltip}
                        isOpen={this.state.timezoneTooltipOpen}
                        target={this.state.timezoneRef}
                      >
                        {this.props.user.timeZone}
                      </Tooltip>
                    }
                  </React.Fragment>
                }
              />
            }
          </div>
          {
            this.props.webcast.title &&
            <b data-bdd='details-panel-title' className={styles['details-panel-title']}>{this.props.webcast.title}</b>
          }
          {
            this.props.webcast.description &&
            <div data-bdd='details-panel-description' className={styles['details-panel-description']}>
              <Truncate lines={!this.state.descriptionOpen && 6} ellipsis={<this.ToggleDescriptionButton />} onTruncate={this.handleTruncateDescription}>
                {this.props.webcast.description}
              </Truncate>
              {
                !this.state.truncatedDescription &&
                this.state.descriptionOpen &&
                <this.ToggleDescriptionButton />
              }
            </div>
          }
        </div>
      }
    />

  }

}

export default DetailsSidePanel
